<template>
  <div class="list" style="width:100%">
    <Header :title="$t('m.HistoryMeetingList')"></Header>
    <div class="contentitem grebgc">
      <div class="itemlist spebgc" :style="{'height': tableHeight+'px'}">
        <p :key="index" @click="tomeetingdetail(item.id)" v-for="(item,index) in meetinghistory">
          <span class="width">{{item.meeting_name}}</span>
          <span class="right width">
            <span class="time">{{item.meeting_date | getdata}}</span>
            <!-- <span class="realtivetime">{{item.meeting_date | gettime}}</span> -->
            <span class="realtivetime">{{gettime(item.meeting_date)}}</span>
          </span>
        </p>
      </div>
      <Page
        v-show="dataCount>0"
        ref="pages"
        class="page_bottom"
        :current.sync="currentPage"
        :total="dataCount"
        simple
        :page-size="pageSize"
        @on-change="chagePage"
      />
    </div>
  </div>
</template>
<script>
import Header from "../../header/header";
import { selectConfList } from "../../../assets/js/url";

export default {
  data() {
    return {
      meetinghistory: [],
      start: 0,
      dataCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableHeight: document.documentElement.clientHeight - 90
    };
  },
  filters: {
    getdata(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      return (
        data.getFullYear() + "/" + (data.getMonth() + 1) + "/" + data.getDate()
      );
    },
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    }
  },
  components: {
    Header
  },
  activated() {
    this.start = 0;
    this.$nextTick(function() {
      this.$refs["pages"].currentPage = 1;
    });
    this.getmeethistorylist();
  },
  methods: {
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    }
    ,
    getmeethistorylist() {
      this.$loadingshow();
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 3,
          start: this.start,
          pagesize: 10
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.meetinghistory = res.data.data;
            this.dataCount = res.data.total;
            if (!this.meetinghistory.length) {
              this.$toast(this.$t('m.NowNoPlanMeetingList'));
              const _this = this;
              setTimeout(function() {
                _this.$router.push("/index");
              }, 200);
            }
          } else {
            this.$toast(this.$t('m.MeetingListGetError'));
          }
        });
    },
    tomeetingdetail(item) {
      this.$router.push({
        name: "meetingdetail",
        query: {
          meetinguuid: item,
          showAddTerminal: false //详情页是否显示扫二维码入会按钮
        }
      });
    },
    chagePage(index) {
      this.start = (index - 1) * 10;
      this.getmeethistorylist();
    }
  }
};
</script>
<style scoped>
.itemlist p {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
}

.itemlist p:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.1);
}

.right {
  float: right;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
  text-decoration: none !important;
}

.right img {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-left: 0.2rem;
}

.width {
  display: inline-block;
  width: 49%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: underline;
}

.time,
.relativetime {
  display: inline-block;
}

.time {
  width: 60%;
  text-align: center;
}

.relativetime {
  width: 40%;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/components/content/indextomeeting/historymeeting.vue